import React, { useEffect, useState } from 'react'
import { quickReplyService } from '../../services/quickReplyService'
import type { QuickReply } from '../../types/quickReply.types'
import { X } from 'lucide-react'

interface QuickRepliesPickerModalProps {
  isOpen: boolean
  onClose: () => void
  onSelect: (content: string) => void
  onOpenManager?: () => void
}

export const QuickRepliesPickerModal: React.FC<QuickRepliesPickerModalProps> = ({
  isOpen,
  onClose,
  onSelect,
  onOpenManager
}) => {
  const [quickReplies, setQuickReplies] = useState<QuickReply[]>([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const load = async () => {
      if (!isOpen) return
      try {
        setIsLoading(true)
        const res = await quickReplyService.getQuickReplies()
        if (res.success && Array.isArray(res.data)) {
          setQuickReplies(res.data)
        } else {
          setQuickReplies([])
        }
      } finally {
        setIsLoading(false)
      }
    }
    load()
  }, [isOpen])

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md max-h-[80vh] flex flex-col">
        <div className="flex items-center justify-between px-4 py-3 border-b">
          <h2 className="text-sm font-semibold text-gray-900">Mensagens rápidas</h2>
          <button
            onClick={onClose}
            className="p-1 rounded hover:bg-gray-100"
          >
            <X className="w-4 h-4 text-gray-500" />
          </button>
        </div>
        <div className="p-3 flex-1 overflow-y-auto space-y-2 text-sm">
          {isLoading ? (
            <p className="text-gray-500 text-center py-4">Carregando...</p>
          ) : quickReplies.length === 0 ? (
            <p className="text-gray-500 text-center py-4">
              Nenhuma mensagem rápida cadastrada.
            </p>
          ) : (
            quickReplies.map(qr => (
              <button
                key={qr.id}
                className="w-full text-left p-2 border rounded hover:bg-blue-50 transition-colors"
                onClick={() => {
                  onSelect(qr.content)
                  onClose()
                }}
              >
                <p className="font-medium text-gray-900 truncate">{qr.title}</p>
                <p className="text-xs text-gray-600 mt-1 line-clamp-2">{qr.content}</p>
              </button>
            ))
          )}
        </div>
        <div className="px-4 py-2 border-t flex items-center justify-between text-xs text-gray-500">
          <span>
            Ao selecionar, o texto será inserido na caixa de mensagem (não é enviado automaticamente).
          </span>
          {onOpenManager && (
            <button
              type="button"
              className="ml-2 text-blue-600 hover:text-blue-700 font-medium"
              onClick={() => {
                onClose()
                onOpenManager()
              }}
            >
              Gerenciar
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

